import React from 'react';
import PropTypes from 'prop-types';
import { Segment, Button, Header } from 'semantic-ui-react';
import PolicyRate from '../PolicyRate';
import styles from './PolicyChange.module.scss';
import ConfirmationModal from './ConfirmationModal';

const PolicyChange = ({ name, policy, rate, children, onComplete, onSaveAndExit, onEdit, onCancel, title, showEdit, hideConfirm }) => {
	return (
		<div>
			<Header>{title}</Header>
			<Segment className={styles.container}>{children}</Segment>
			{rate && <PolicyRate policy={policy} rate={rate} />}

			<div className={styles.buttons}>
				{hideConfirm && <Button id="completeChangeBtn" primary onClick={onComplete}>Complete Change</Button>}

				{!hideConfirm && (
					<ConfirmationModal onContinue={onComplete}>
						<Button id="completeChangeBtn" primary>Complete Change</Button>
					</ConfirmationModal>
				)}

				<Button id="saveAndExitBtn" primary onClick={onSaveAndExit}>
					Save and Exit
				</Button>
				{showEdit && (
					<Button id="editBtn" primary onClick={onEdit}>
						Edit {name}
					</Button>
				)}
				<Button id="cancelBtn" primary onClick={onCancel}>
					Cancel
				</Button>
			</div>
		</div>
	);
};

PolicyChange.propTypes = {
	name: PropTypes.string.isRequired,
	policy: PropTypes.object.isRequired,
	newPolicy: PropTypes.object.isRequired,
	children: PropTypes.any.isRequired,
};

export default PolicyChange;
